export default __webpack_public_path__ + "static/media/4783.6cb0be46.png";